import { Contract, Status } from "../../models/ContractTypes";
import ActionWorkspaceButton from "../../components/ActionWorkspaceButton";
import { ActionWorkspaceButtonConfig } from "../../components/ActionWorkspaceButton";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import LinkIcon from "@mui/icons-material/Link";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import "moment/locale/fr";
import * as React from "react";
import { useStatusService } from "../Status/StatusService";
import { useWorkspaceService } from "./WorkspaceService";
import { useEffect, useState } from "react";
import { StoreGetWorkspaceStatus } from "../../hooks/SharePointStore";

export function ContractDetails({ choosenContract, currentUser }: any) {
  let choosenContractOne: Contract = choosenContract[0];
  const [workspaceStatus, setWorkspaceStatus] = useState<Status>();
  const [creationButtonIsClicked, setCreationButtonIsClicked] = useState(false);

  // Utilisation du service de gestion des statuts
  const workspaceService = useWorkspaceService(
    choosenContract,
    creationButtonIsClicked
  );
  const statusService = useStatusService(
    choosenContract,
    workspaceService.responseCodeSp,
    workspaceStatus
  );

  const { getWorkspaceStatus, responseGetWorkspaceStatus } = StoreGetWorkspaceStatus();

  useEffect(() => {
    getWorkspaceStatus(choosenContractOne.projectId);
  }, [choosenContractOne?.projectId,workspaceStatus]);

  const sharepointProjectLink = `https://biotope34.sharepoint.com/sites/sp-prod-be-${workspaceService.responseCodeSp?.code_sp}/Etudes/Forms/AllItems.aspx?id=%2Fsites%2Fsp%2Dprod%2Dbe%2D${workspaceService.responseCodeSp?.code_sp}%2FEtudes%2F${choosenContractOne.projectId}`;
  const isProvisioned = responseGetWorkspaceStatus?.buttonToEnable === "ARCHIVER";

  function handleWorkspaceArchiving() {
    setWorkspaceStatus(Status.ARCHIVER);
  }

  function handleWorkspaceRestoration() {
    setWorkspaceStatus(Status.RESTAURER);
  }

  function handleWorkspaceCreation() {
    setCreationButtonIsClicked(true);
  }

  const statusConfigs: ActionWorkspaceButtonConfig[] = [
    {
      type: Status.CREER,
      label: "Création de l'espace documentaire de l'étude",
      onClick: handleWorkspaceCreation,
      successMessage: "La demande de création a été effectuée par",
    },
    {
      type: Status.ARCHIVER,
      label: "Demande d'archivage",
      onClick: handleWorkspaceArchiving,
      successMessage: "La demande d'archivage a été effectuée par",
    },
    {
      type: Status.RESTAURER,
      label: "Demande de restauration",
      onClick: handleWorkspaceRestoration,
      successMessage: "La demande de restauration a été effectuée par",
    },
  ];

  const card = (
    <React.Fragment>
      <CardContent>
        <Typography variant="h5" component={"span"}>
          Identifiant projet: {choosenContractOne.projectId}
        </Typography>
        <br />
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {choosenContractOne.projectKey}: {choosenContractOne.projectName}
        </Typography>
        <br />
        <List>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <ApartmentIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary={choosenContractOne.serviceName} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <CoPresentIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary={choosenContractOne.customerName} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <ContactMailIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary={choosenContractOne.projectSupervisorEmail} />
            </ListItemButton>
          </ListItem>
          {/* Affichage du lien shp du projet si le code sp du service exite bien */}
          {workspaceService.responseCodeSp && isProvisioned && (
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <LinkIcon color="secondary" />
                </ListItemIcon>
                <Link
                  href={sharepointProjectLink}
                  underline="hover"
                  variant="body1"
                  target="_blank"
                  rel="noopener nofollow"
                >
                  {"Lien sharepoint du projet"}
                </Link>
              </ListItemButton>
            </ListItem>
          )}
        </List>
      </CardContent>
      {/* Erreur code SharePoint du service manquant */}
      {!workspaceService.responseCodeSp && (
        <Alert severity="error">
          Le code sharepoint du service n'existe pas
        </Alert>
      )}
      {statusConfigs.map((config) => (
        <ActionWorkspaceButton
          key={config.type}
          config={config}
          responseLocalStatus={statusService.responseStatus}
          responseCodeSp={workspaceService.responseCodeSp}
          responseGetWorkspaceStatus={responseGetWorkspaceStatus}
          choosenContractOne={choosenContractOne}
          currentUser={currentUser}
        />
      ))}
    </React.Fragment>
  );

  return (
    <Box sx={{ minWidth: 275 }}>
      <Card variant="outlined">{card}</Card>
      {false &&
        !workspaceService.errorRequestProjectWorkspace &&
        workspaceService.responseRequestProjectWorkspace?.id != undefined && (
          <Alert severity="success">L'espace est crée avec succès.</Alert>
        )}
      {false &&
        workspaceService.errorRequestProjectWorkspace != undefined &&
        workspaceService.responseAddedItem != undefined && (
          <Alert severity="error">Une erreur est survenue.</Alert>
        )}
      {false &&
        !statusService.errorUpdateWorkspaceStatus &&
        statusService.responseUpdateWorkspaceStatus?.id != undefined && (
          <Alert severity="success">La demande a bien été envoyée.</Alert>
        )}
      {false && statusService.errorUpdateWorkspaceStatus != undefined && (
        <Alert severity="error">
          Une erreur est survenue lors de la mise à jour du statut du projet.
        </Alert>
      )}
    </Box>
  );
}
